import angular from 'angular';

import { LoginController } from './login.controller';

angular
    .module('upglide.module.login', [])
    .controller('LoginController', LoginController);


// WEBPACK FOOTER //
// ./Angular_Code/app/Login/login.module.js